var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReporting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "simple-line-icons:docs",
    clipPath: "url(#clip0_16_4166)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M27 0H14.625C13.3824 0 12.375 1.00744 12.375 2.25H24.75V11.25H33.75V29.25H25.875V31.5H33.75C34.9926 31.5 36 30.4926 36 29.25V9.00056L27 0ZM27 9V3.1815L32.8174 9H27ZM2.25 4.5C1.00744 4.5 0 5.50744 0 6.75V33.75C0 34.9926 1.00744 36 2.25 36H21.375C22.6176 36 23.625 34.9926 23.625 33.75V13.5006L14.625 4.5H2.25ZM21.375 33.75H2.25V6.75H12.375V15.75H21.375V33.75ZM14.625 13.5V7.6815L20.4424 13.5H14.625Z",
    fill: "#909090"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16_4166"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReporting);
export default __webpack_public_path__ + "static/media/reporting.30e91e1fd54c00e5414a3ea5095463fd.svg";
export { ForwardRef as ReactComponent };